"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.requestAndDownloadAttachment = exports.TextWithCopy = exports.CopyButton = exports.Truncate = void 0;
var react_1 = __importDefault(require("react"));
var FileCopyOutlined_1 = __importDefault(require("@material-ui/icons/FileCopyOutlined"));
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
exports.Truncate = function (_a) {
    var s = _a.s, _b = _a.max, max = _b === void 0 ? 40 : _b;
    if (s.length > max) {
        return react_1["default"].createElement("span", { title: s },
            s.slice(0, max),
            " ...");
    }
    return react_1["default"].createElement("span", null, s);
};
exports.CopyButton = function (_a) {
    var value = _a.value;
    return (react_1["default"].createElement(IconButton_1["default"], { title: "copy value", size: "small", onClick: function () { return navigator.clipboard.writeText(value); } },
        react_1["default"].createElement(FileCopyOutlined_1["default"], null)));
};
exports.TextWithCopy = function (_a) {
    var value = _a.value;
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement(exports.CopyButton, { value: value }),
        " ",
        react_1["default"].createElement(exports.Truncate, { s: value })));
};
exports.requestAndDownloadAttachment = function (url, jbody, filename, method) {
    if (method === void 0) { method = 'POST'; }
    var body = JSON.stringify(jbody);
    fetch(url, {
        method: 'POST',
        body: body,
        headers: { 'Content-Type': 'application/json' }
    })
        .then(function (x) { return x.blob(); })
        .then(function (blob) {
        var file = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        document.body.appendChild(a);
        a.href = file;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(file);
    });
};
